export default {
  "content": "<path d=\"M14 15H5v-2h9v2zM19 15h-3v-2h3v2zM6.317 8.75a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zM10.25 8.75a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zM14 8.75a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zM17.75 8.71a1.25 1.25 0 110 2.502 1.25 1.25 0 010-2.501z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M21 5a2 2 0 012 2v10a2 2 0 01-2 2H3a2 2 0 01-2-2V7a2 2 0 012-2h18zM3 17h18V7H3v10z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};